(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb786"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb786"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hNfk1", function(module, exports) {
if (window.location.href.includes(".de/policies/privacy-policy")) {
    const policyBody = document.querySelector(".shopify-policy__body");
    if (!policyBody) return;
    const iframe = `<iframe style="border: 0;" src="https://app.alfright.eu/ext/dps/prodata_scan/717ff3b3c71a4ead810b4cdeefbb9493?lang=de-de&amp;headercolor=#436a8b&amp;headerfont=Arial&amp;headersize=21px&amp;subheadersize=18px&amp;fontcolor=#333333&amp;textfont=Arial&amp;textsize=14px&amp;background=#ffffff&amp;linkcolor=#337ab7" width="100%" height="5000"></iframe>`;
    policyBody.innerHTML = iframe;
}

});

parcelRequire("hNfk1");



})();
//# sourceMappingURL=parcel_scripts.js.map
